import { EN_LOCALE, DEFAULT_LOCALE, isPublicLocalizedPath } from './routing';

/** Force FR on public root URLs; EN only under /en. */
const pathLanguageDetector = {
  name: 'path',
  lookup() {
    const pathname = window.location.pathname;
    if (pathname === '/en' || pathname.startsWith('/en/')) {
      return EN_LOCALE;
    }
    if (isPublicLocalizedPath(pathname)) {
      return DEFAULT_LOCALE;
    }
    return undefined;
  },
};

export default pathLanguageDetector;
